import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';

import ABWorkReporting from '../../settings/ABWorkReporting/ABWorkReporting';
import { saveCompanySettings } from '../../settings/state/settings.actions';
import {
  getABWorkReportingDisplayFields,
  saveABWorkReportingDisplayFields,
  getABWorkReportingMapping,
  saveABWorkReportingMapping,
} from '../../abWorkReporting/state/abWorkReporting.actions';

export default function BoardCardABWorkReportingSettingsDrawer({
  visible,
  onClose,
}) {
  const dispatch = useDispatch();
  const company = useSelector((state) => state.settings.company);
  const { settings } = company || {};
  const userDisplayFields = useSelector((state) => state.abWorkReporting.displayFields);
  const importMapping = useSelector((state) => state.abWorkReporting.mapping);

  useEffect(() => {
    dispatch(getABWorkReportingDisplayFields());
    dispatch(getABWorkReportingMapping());
  }, []);

  const onSaveSettings = async (newSettings) => {
    await dispatch(saveCompanySettings(newSettings));
  };

  const onSaveDisplayFields = async (fields) => {
    await dispatch(saveABWorkReportingDisplayFields(fields));
  };

  const onSaveImportMapping = async (payload) => {
    await dispatch(saveABWorkReportingMapping(payload));
  };

  return (
    <Drawer
      title="AB Work Reporting Settings"
      visible={visible}
      onClose={onClose}
      width={600}
      push
    >
      <ABWorkReporting
        settings={settings}
        saveCompanySettings={onSaveSettings}
        saveDisplayFields={onSaveDisplayFields}
        userDisplayFields={userDisplayFields}
        importMapping={importMapping}
        onSaveImportMapping={onSaveImportMapping}
      />
    </Drawer>
  );
}

BoardCardABWorkReportingSettingsDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
